var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7468 19.188C23.4678 20.4378 22.5627 22 21.1227 22H2.37712C0.934269 22 0.0334097 20.4354 0.753019 19.188L10.1259 2.93691C10.8473 1.68656 12.654 1.68883 13.3741 2.93691L22.7468 19.188ZM11.75 15.8281C10.7576 15.8281 9.95314 16.6326 9.95314 17.625C9.95314 18.6174 10.7576 19.4219 11.75 19.4219C12.7424 19.4219 13.5469 18.6174 13.5469 17.625C13.5469 16.6326 12.7424 15.8281 11.75 15.8281ZM10.044 9.3693L10.3338 14.6818C10.3474 14.9304 10.5529 15.125 10.8018 15.125H12.6982C12.9471 15.125 13.1527 14.9304 13.1662 14.6818L13.456 9.3693C13.4706 9.10078 13.2568 8.875 12.9879 8.875H10.512C10.2431 8.875 10.0294 9.10078 10.044 9.3693Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.7bde91bad2511c959e090cd4d7ea10c2.svg";
export { ForwardRef as ReactComponent };